// Chakra imports
import { Box, Flex } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import Footer from "components/footer/FooterAdmin";

// Custom components
import { NavLink } from "react-router-dom";
// Assets

function AuthIllustration(props) {
  const { children, illustrationBackground } = props;
  // Chakra color mode
  return (
    <Flex position='relative' flexDirection='column'>
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w='100%'
        maxW={{ md: "66%", lg: "1313px" }}
        mx='auto'
        pt={{ sm: "0px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
      >
        <Flex
          direction="column"
          flex="1"
          minW={0}
          minH="100vh"
        >
          <NavLink
            to='/admin'
            style={() => ({
              width: "fit-content",
              marginTop: "40px",
            })}>
          </NavLink>
          {children}
        </Flex>
        <Box
          display={{ base: "none", md: "flex", }}
          alignItems="center"
          justifyContent="center"
          h='100%'
          minH='100vh'
          w={{ lg: "50vw", xl: "36vw", "2xl": "32vw" }}
          bgImage={`url(${illustrationBackground})`}
          bgRepeat="no-repeat"
          bgPosition="center"
          bgSize="contain"
        />
      </Flex>
      <Footer />
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
